import { Link } from "react-router-dom";
import AppShell from "@/components/AppShell";
import { useMe } from "@/context/MeContext";

export default function NotYet() {
  const { me } = useMe();
  if (me?.tester) return (
    <AppShell>
      <div className="ahu-card p-8 fade-in" data-testid="tester-plan-used">
        <p className="eyebrow mb-3">Thank you</p>
        <h1 className="text-2xl sm:text-3xl">Thank you for testing AHU</h1>
        <p className="mt-4 text-ink-soft leading-relaxed">You've made your Action Plan, and it's yours to keep and work through. Starting new plans opens when AHU launches, and we'll let you know.</p>
        <Link to="/plans" className="btn-charcoal mt-8" data-testid="tester-plans-btn">Go to my plan</Link>
      </div>
    </AppShell>
  );
  return (
    <AppShell>
      <div className="ahu-card p-8 fade-in" data-testid="plans-not-open">
        <p className="eyebrow mb-3">Coming soon</p>
        <h1 className="text-2xl sm:text-3xl">Action Plans aren't open just yet</h1>
        <p className="mt-4 text-ink-soft leading-relaxed">We're putting the finishing touches on AHU. {me?.plans_created ? "Your plans are saved and ready for you. We'll let you know as soon as you can start a new one." : "Your account and your three baskets are saved, and we'll let you know as soon as you can start your first plan."}</p>
        <Link to="/" className="btn-charcoal mt-8" data-testid="not-yet-home-btn">Go to Home</Link>
      </div>
    </AppShell>
  );
}
